import { getIndexerValueForMailboxInfo } from "owa-client-types";
import type { FavoriteCategoryData, FavoriteData, FavoriteFolderData, FavoriteGroupData, FavoritePublicFolderData, } from "owa-favorites-types";
import { type FolderForestNodeType } from "owa-favorites-types";
import type { RetainedFolderForFavoritesSideRail } from "../hooks/useRetainedFolderForFavoritesSideRail";

/**
 * Finds the favorite that corresponds to the node retained for the favorites side rail.
 * Matches against each favorite's own data, using the same id the selection actions put
 * on the selected node for that favorite type.
 */
export default function getRetainedFavoriteId(retained: RetainedFolderForFavoritesSideRail | undefined, favoriteIds: readonly string[], outlookFavorites: {
    get(favoriteId: string): FavoriteData | undefined;
}): string | undefined {
    if (!retained) {
        return undefined;
    }
    
    return favoriteIds.find(favoriteId => {
        const data = outlookFavorites.get(favoriteId);
        return !!data && isRetainedFavorite(retained, data);
    });
}

function isRetainedFavorite(retained: RetainedFolderForFavoritesSideRail, data: FavoriteData): boolean {
    switch (data.type) {
        case "folder":
        case "localFolderArchive":
        case "localFolderShared":
        case "localFolderPst":
            return (!!retained.folderId && (data as FavoriteFolderData).folderId === retained.folderId);
        case "category":
            return (retained.nodeType === 4 &&
                (data as FavoriteCategoryData).categoryId === retained.nodeId);
        case "persona":
            return (retained.nodeType === 1 &&
                data.favoriteId === retained.nodeId);
        case "group":
            return (retained.nodeType === 2 &&
                (data as FavoriteGroupData).groupId?.toLowerCase() ===
                    retained.nodeId.toLowerCase() &&
                (!retained.mailboxInfo ||
                    !data.mailboxInfo ||
                    getIndexerValueForMailboxInfo(retained.mailboxInfo) ===
                        getIndexerValueForMailboxInfo(data.mailboxInfo)));
        case "publicFolder":
            return (retained.nodeType === 5 &&
                (data as FavoritePublicFolderData).publicFolderId === retained.nodeId);
        default:
            return false;
    }
}
